<template>
  <div class="getCert">
    <div class="title">
      <h1>生成证书</h1>
    </div>

    <div class="contentBox">
      <div class="contentBox-left">
        <div class="imgZone">
          <img
            src="~@/assets/images/event/oneHourCode/cert-border.png"
            id="sideImg"
          />
          <img id="mainImg" />
        </div>
      </div>
      <div class="contentBox-right">
        <section class="clickZone">
          <p v-if="nonUserInfo == false" v-html="downloadText"></p>
          <p v-if="nonUserInfo == true" v-html="downloadText2"></p>

          <p>
            <i
              v-if="nonUserInfo == false"
              class="downloadCert"
              @click="downloadCertBtn(1, 3508, 2481), (DLclick = 0)"
            ></i>
          </p>
          <p><i v-if="nonUserInfo == true" class="downloadCert-non"></i></p>
          <p>
            <!-- <span v-if="DLclick === -2">证书下载出错，请重试！</span> -->
            <span v-if="DLclick === 0">证书下载中，请稍候...</span>
            <!-- <span v-if="DLclick === 1">证书下载完成！</span> -->
          </p>
        </section>

        <section class="clickZone">
          <p v-html="continueText"></p>

          <i class="continue" @click="continueBtn()"></i>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import MediaUtils from "../utils/MediaUtils";

export default {
  data() {
    return {
      name: "",
      certId: "",
      time: "",
      nonUserInfo: false,
      DLclick: -1,

      downloadText: "恭喜您！<br/>您的证书已经成功生成！",
      downloadText2: "未接收到用户信息，<br/>非常抱歉，<br/>证书生成失败！",
      continueText:
        "意犹未尽？挑战更多关卡吧！<br/>使用手机号即可注册学习平台，<br/>2000+关卡等你来挑战！",
    };
  },

  methods: {
    // 下载证书 - 按钮
    // type =1 下载证书 ； type=2 左侧的预览证书
    downloadCertBtn(type, width, height) {
      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      // let ratio = this.ratio(context);
      let ratio = 1;

      let canvasWidth = width,
        canvasHeight = height;

      canvas.width = canvasWidth * ratio;
      // console.log(canvas.width);
      canvas.height = canvasHeight * ratio;
      // console.log(canvas.height);
      // console.log(ratio);

      //因为拿不到图片静态资源，所以创建图片标签
      let img = new Image();
      //解决图片跨域问题,也要放到赋值前，否贼大部分浏览器会报错
      img.setAttribute("crossOrigin", "anonymous");
      // 证书背景
      switch (type) {
        // 下载
        case 1: {
          img.src =
            MediaUtils.getStaticDomain() + "assets/template/v2020121101.png";
          break;
        }

        // 预览
        case 2: {
          img.src =
            MediaUtils.getStaticDomain() + "assets/template/v2020120901.png";
          break;
        }
      }

      try {
        img.onload = () => {
          context.drawImage(
            img,
            0,
            0,
            canvasWidth * ratio,
            canvasHeight * ratio
          );

          // 内容居中
          context.textAlign = "center";
          {
            // 姓名
            if (type == 1) {
              context.font = "700 " + 120 * ratio + "px" + " 微软雅黑";
            } else if (type == 2) {
              context.font = "700 " + 25 * ratio + "px" + " 微软雅黑";
            }
            // 颜色
            context.fillStyle = "#016863";
            // 定位
            context.fillText(
              this.name,
              (canvasWidth / 2) * ratio,
              canvasHeight * 0.51 * ratio
            );
          }
          {
            // 编号
            if (type == 1) {
              context.font = "700 " + 60 * ratio + "px" + " 微软雅黑";
            } else if (type == 2) {
              context.font = "700 " + 14 * ratio + "px" + " 微软雅黑";
            }
            // 颜色
            context.fillStyle = "#016863";
            // 定位
            context.fillText(
              this.certId,
              (canvasWidth / 2) * ratio,
              canvasHeight * 0.718 * ratio
            );
          }
          {
            // 日期
            if (type == 1) {
              context.font = "700 " + 80 * ratio + "px" + " 微软雅黑";
            } else if (type == 2) {
              context.font = "700 " + 17 * ratio + "px" + " 微软雅黑";
            }
            // 颜色
            context.fillStyle = "#000";
            // 定位
            context.fillText(
              this.time,
              (canvasWidth / 2) * ratio,
              canvasHeight * 0.835 * ratio
            );
          }

          // 合成图片
          context.save();
          context.restore();
          let base64 = canvas.toDataURL("image/png");

          if (type == 2) {
            let imgs = document.getElementById("mainImg");
            imgs.src = base64;
            return;
          }

          // 下载图片
          this.downloadPHOTO(base64, this.name);
        };
      } catch (error) {
        console.debug("error", error);
      }
    },

    // canvas图片支持
    /*     ratio(context) {
      const backingStore =
        context.backingStorePixelRatio ||
        context.webkitBackingStorePixelRatio ||
        context.mozBackingStorePixelRatio ||
        context.msBackingStorePixelRatio ||
        context.oBackingStorePixelRatio ||
        context.backingStorePixelRatio ||
        1;
      console.log("backingStore", backingStore);
      console.log("window.devicePixelRatio:", window.devicePixelRatio);
      return (window.devicePixelRatio || 1) / backingStore;
    }, */

    downloadPHOTO(path, name) {
      try {
        const xhr = new XMLHttpRequest();
        xhr.open("get", path);
        xhr.responseType = "blob";

        /*        
        xhr.addEventListener("progress", (e) => {
          if (e.lengthComputable) {
            let percentage = e.loaded / e.total;
            if (percentage == 1) {
              this.DLclick = 1;
            }
          } else {
            this.DLclick = -2;
          }
        });
        */

        xhr.send();
        xhr.onload = function () {
          if (this.status === 200 || this.status === 304) {
            // 如果是IE10及以上，不支持download属性
            // 采用msSaveOrOpenBlob方法，但是IE10以下也不支持msSaveOrOpenBlob
            if ("msSaveOrOpenBlob" in navigator) {
              navigator.msSaveOrOpenBlob(this.response, name);
              return;
            }

            const url = URL.createObjectURL(this.response);
            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "编程一小时证书.png";
            // 不插入到dom，在火狐浏览器直接触发a.click是不会触发下载的，需要插入到dom里
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          }
        };

        // 完成
        this.DLclick = 1;
      } catch (error) {
        console.debug("DrawPhoto", error);
      }
    },

    // 继续挑战 - 按钮
    continueBtn() {
      setTimeout(() => {
        this.$router.push({ path: "/" });
      }, 500);
    },
  },

  mounted() {
    let userName = sessionStorage.getItem("certName");
    let phone = sessionStorage.getItem("certPhone");
    let userCertId = sessionStorage.getItem("certId");
    let userCertTime = sessionStorage.getItem("certTime");

    if (userName == null || phone == null) {
      this.nonUserInfo = true;

      this.$message.error({
        message: "未获取到用户证书信息，code: ohc-g-2。请联系ICode管理员",
        duration: 4000,
      });
    } else {
      this.name = userName;
      this.certId = userCertId;
      this.time = userCertTime;

      // const dt = new Date();
      // this.time =
      //   dt.getFullYear() +
      //   "-" +
      //   (dt.getMonth() + 1) +
      //   "-" +
      //   (dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate());
      console.debug("time", this.time);
    }
    this.downloadCertBtn(2, 767, 543);
  },
};
</script>

<style lang="scss">
.getCert {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  min-height: 100vh;
  text-align: center;

  .title {
    width: 40vw;
    height: 10vh;
    margin-top: 3vw;

    h1 {
      width: 100%;
      color: #0ff;
      font-size: 2vw;
      line-height: 3vw;
      background: url("~@/assets/images/event/oneHourCode/cert-title.png")
        center / contain no-repeat;
    }
  }

  .contentBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100vw;

    &-left {
      width: 60vw;
      display: flex;
      justify-content: flex-end;

      .imgZone {
        position: relative;
        width: 47vw;
        height: 70vh;
        margin-right: -3vw;
        // background: url("~@/assets/images/event/oneHourCode/cert-main.png")
        //   center / contain no-repeat;
        transform: scale(0.8);
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          position: absolute;
          left: 0;
          right: 0;
          width: 100%;
          height: 100%;
          margin-left: -1vw;
        }

        #sideImg {
          z-index: 2;
        }

        #mainImg {
          transform: scale(0.95);
          z-index: 3;
        }
      }
    }

    &-right {
      width: 40vw;
      height: 55vh;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .clickZone {
        width: 40vh;
        height: 100%;
        color: #fff;

        p {
          font-size: 1.3vw;
          font-weight: bold;
          text-align: left;

          span {
            color: #2fcc9d;
            font-size: 0.8vw;
            padding-left: 1vw;
          }
        }

        .downloadCert {
          display: block;
          width: 11vw;
          height: 6vh;
          margin-top: 4vh;
          background: url("~@/assets/images/event/oneHourCode/cert-dlCert.png")
            center / contain no-repeat;
          cursor: pointer;
          transition: 0.4s ease all;

          &:hover {
            transform: scale(1.05);
          }

          &-non {
            display: block;
            width: 11vw;
            height: 6vh;
            margin-top: 4vh;
            background: url("~@/assets/images/event/oneHourCode/cert-dlCert-non.png")
              center / contain no-repeat;
            cursor: not-allowed;
          }
        }

        .continue {
          display: block;
          width: 13vw;
          height: 13vh;
          margin-top: 4vh;
          background: url("~@/assets/images/event/oneHourCode/cert-continue.png")
            center / contain no-repeat;
          cursor: pointer;
          transition: 0.4s ease all;

          &:hover {
            transform: scale(1.05);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ohcGetCert.vue